class FinanceInterfaces {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/finance`;

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  async getPaginatedFinanceActivitiesByQueryOptions(queryOptions) {

    const path = `${this.basePath}/activities`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getFinanceActivityForDisplay(financeActivityId) {

    const path = `${this.basePath}/activities/:financeActivityId`;

    return this.apiClient.get(path, { financeActivityId }, {});

  }

  async buildInvoice(invoice) {

    const path = `${this.basePath}/invoices`;

    return this.apiClient.post(path, {}, {}, invoice);

  }

  async executePayout(payout) {

    const path = `${this.basePath}/payouts`;

    return this.apiClient.post(path, {}, {}, payout);

  }

  async setupPayoutDestination(payoutDestination) {

    const path = `${this.basePath}/payout-destinations`;

    return this.apiClient.post(path, {}, {}, payoutDestination);

  }

  async getPayoutDestinationsByQueryOptions(queryOptions) {

    const path = `${this.basePath}/payout-destinations`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async createOrUpdateDefaultPayoutDestination(payoutDestination) {

    const path = `${this.basePath}/default-payout-destination`;

    return this.apiClient.post(path, {}, {}, payoutDestination);

  }

  async getDefaultPayoutDestination() {

    const path = `${this.basePath}/default-payout-destination`;

    return this.apiClient.get(path, {}, {});

  }

  async updatePayoutSchedule(schedule) {

    const path = `${this.basePath}/payout-schedule`;

    return this.apiClient.post(path, {}, {}, schedule);

  }

}

export default FinanceInterfaces;